
import ViewBox from 'vux/src/components/view-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
ViewBox,
Group,
Cell,
Checklist,
PopupPicker,
XInput,
XTextarea,
XButton
},
data () {
return {
districtList: [['Shanghai', 'Jiangsu', 'Hubei']],
vehicleList: ['自备车', '教练车'],
district: [],
coach: [],
vehicle: [],
startAddress: '',
endAddress: '',
notes: ''
}
},
methods: {
onSubmitClick () {
console.log('district: ' + this.district)
console.log('coach: ' + this.coach)
console.log('vehicle: ' + this.vehicle)
console.log('startAddress: ' + this.startAddress)
console.log('endAddress: ' + this.endAddress)
console.log('notes: ' + this.notes)
}
}
}



// WEBPACK FOOTER //
// ./src/views/schedule.vue